const createAlarm = function(data, fn) {

  const init = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Basic '+btoa('myapiuser:123456'),
    },
    body: JSON.stringify(data),
  };

  fetch('/api/alarms/', init)
    .then(response => {
      return response.json();
    }).then(json => {
      fn(json);
    }).catch(function(err) {
      console.log('parsing failed', err);
    });
}

export {
  createAlarm
};



// WEBPACK FOOTER //
// ./src/requests/createAlarm.js